var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook_f_logo_(2021)",
    clipPath: "url(#clip0_180_511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.51451 17.91C3.23951 17.145 -0.000488281 13.455 -0.000488281 9C-0.000488281 4.05 4.04951 0 8.99951 0C13.9495 0 17.9995 4.05 17.9995 9C17.9995 13.455 14.7595 17.145 10.4845 17.91L9.98951 17.505H8.00951L7.51451 17.91Z",
    fill: "url(#paint0_linear_180_511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5096 11.52L12.9146 9.00001H10.5296V7.24501C10.5296 6.52501 10.7996 5.98501 11.8796 5.98501H13.0496V3.69001C12.4196 3.60001 11.6996 3.51001 11.0696 3.51001C8.99957 3.51001 7.55957 4.77001 7.55957 7.02001V9.00001H5.30957V11.52H7.55957V17.865C8.05457 17.955 8.54957 18 9.04457 18C9.53957 18 10.0346 17.955 10.5296 17.865V11.52H12.5096Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_511",
    x1: 8.99996,
    y1: 17.374,
    x2: 8.99996,
    y2: -0.0033155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(-0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.7fa5a8e751d302e80124213ae904179e.svg";
export { ForwardRef as ReactComponent };